import { Controller, Control } from 'react-hook-form';
import { LocalizationProvider, TimePicker as TimePickerComponent } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

interface Props {
  name: string;
  control: Control<any>;
  label?: string;
}

export default function TimePicker({ name, control, label }: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const parsedTime =
            field.value !== 'undefined' && Boolean(field.value)
              ? dayjs(field.value, 'h:mm') // Adjusting format for AM/PM
              : null;
          return (
            <DemoContainer components={['TimePicker']}>
              <TimePickerComponent
                {...field}
                label={label}
                value={parsedTime}
                onChange={(newValue) => {
                  const formattedValue = newValue ? newValue.format('HH:mm') : null;
                  field.onChange(formattedValue);
                }}
                ampm={true}
              />
            </DemoContainer>
          );
        }}
      />
    </LocalizationProvider>
  );
}
